import React from "react";
import { Stage, Layer, Image, Text } from "react-konva";
import TemplateImage from "./TemplateImage";
import { size, textFrame, bookFrame } from "./consts";
import { Spinner } from "react-bootstrap";

export default function Viewer({
  canvasRef = null,
  canvasRealRef = null,
  scale = 1,
  image = new Image(),
  text = "",
  book = "",
  color = "#FFFFFF",
  fontLoaded = false,
  textSize = 100,
  font = "Arial",
  width = size.width,
  height = size.height,
}) {
  return (
    <div className="flex w-full h-full items-stretch justify-stretch">
      {/*Off screen*/}
      <div className={"hidden"}>
        <Stage
          width={size.width}
          height={size.height}
          scale={scale}
          ref={canvasRealRef}
        >
          <Layer>
            <TemplateImage image={image} />
            <Text
              text={`"${text}"`}
              x={textFrame.x}
              y={textFrame.y}
              fill={color}
              wrap={"word"}
              align={"center"}
              verticalAlign={"middle"}
              fontFamily={fontLoaded ? font : "Arial"}
              fontSize={textSize}
              width={textFrame.width}
              height={textFrame.height}
              lineHeight={1.2}
            />
            <Text
              text={`(${book})`}
              x={bookFrame.x}
              y={bookFrame.y}
              fill={color}
              wrap={"word"}
              align={"center"}
              verticalAlign={"middle"}
              fontFamily={fontLoaded ? font : "Arial"}
              fontSize={60}
              width={bookFrame.width}
              height={bookFrame.width}
            />
          </Layer>
        </Stage>
      </div>
      <div
        className={
          "relative h-screen max-h-screen w-full flex items-stretch justify-stretch"
        }
      >
        {!fontLoaded && (
          <div className={"stage-loading"}>
            <Spinner animation={"border"} size={"xl"} variant={"primary"} />
          </div>
        )}
        <div
          id={"stage-parent"}
          className="w-5/6 h-5/6 flex items-center justify-center m-auto"
        >
          <Stage
            className="canvas-stage shadow ring ring-rose-500"
            width={width}
            height={height}
            scale={scale}
            ref={canvasRef}
          >
            <Layer>
              <TemplateImage image={image} scale={scale} />
              <Text
                text={`"${text}"`}
                x={textFrame.x * scale}
                y={textFrame.y * scale}
                fill={color}
                wrap={"word"}
                align={"center"}
                verticalAlign={"middle"}
                fontFamily={fontLoaded ? font : "Arial"}
                fontSize={textSize * scale}
                width={textFrame.width * scale}
                height={textFrame.height * scale}
                lineHeight={1.2}
              />
              <Text
                text={`(${book})`}
                x={bookFrame.x * scale}
                y={bookFrame.y * scale}
                fill={color}
                wrap={"word"}
                align={"center"}
                verticalAlign={"middle"}
                fontFamily={fontLoaded ? font : "Arial"}
                fontSize={60 * scale}
                width={bookFrame.width * scale}
                height={bookFrame.width * scale}
              />
            </Layer>
          </Stage>
        </div>
      </div>
    </div>
  );
}
